import React, { useState, useRef, useEffect } from "react";
import RightDrawer from "../../../components/ui/RightDrawer";
import Inputfield from "../../../components/ui/inputField";
import { ValidatorForm } from "react-material-ui-form-validator";
import DatePicker from "../../../components/ui/DatePicker";
import axios from "../../../axios-order";
import BoxWrapper from "../../../components/ui/boxWrapper";
import { useHistory } from "react-router-dom";
import Modal from "@mui/material/Modal";
import { Grid, Tooltip } from "@material-ui/core";
import { Button } from "@mui/material";
import Box from "@mui/material/Box";
import RemoveRedEyeOutlinedIcon from "@mui/icons-material/RemoveRedEyeOutlined";
import CircularProgress from "@mui/material/CircularProgress";
import { FormControl, InputLabel, Select, MenuItem, Snackbar, Alert } from '@mui/material';
import Chip from '@mui/material/Chip';
import moment from "moment";
import ToggleSwitch from "../../../components/ui/ToggleSwitch/ToggleSwitch";
import RefreshIcon from '@mui/icons-material/Refresh';
import excelIconImage from '../../../asserts/images/excelicon.svg'
import { IconButton } from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { canRead, canWrite } from "../../../utils/privilegeUtils";


const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 400,
    bgcolor: "background.paper",
    border: "2px solid #000",
    boxShadow: 24,
    p: 4,
};

const GstLedgers = () => {
    let history = useHistory();
    const form = useRef("form");
    const [username, setUserName] = useState("");
    const [openEstablisConnectionDrawer, setOpenEstablisConnectionDrawer] = useState(false);
    const [openOTPModal, setOpenOTPModal] = useState(false);
    const [auth_otp, setAuthOTP] = useState("");
    const [establishConnectionButton, setEstablisConnectionButton] = useState("button-outlined-secondary");
    const [successMessage, setSuccessMessage] = useState("");
    const [otpApiData, setOtpApidata] = useState({});
    const [authAPiResData, setAuthApiResData] = useState({});
    const [gstLederList, setGstLedgerList] = useState([]);
    const [authToken, setAuthToken] = useState("");
    const [loading, setLoading] = useState(false);
    const [errorForFileUploadForm, setErrorForFileUploadForm] = useState("");
    const [fromDateAndMonthAndYear, setFromDateAndMonthAndYear] = useState("");
    const [toDateAndMonthAndYear, setToDateAndMonthAndYear] = useState("");
    const [fromDateMonthYearDisplay, setFromDateMonthYearDisplay] = useState(null);
    const [toDateMonthYearDisplay, setToDateMonthYearDisplay] = useState(null);
    const [selectedReportType, setSelectedReportType] = useState('CASH')
    const [snackbarOpen, setSnackbarOpen] = useState(false);
    const [snackbarSeverity, setSnackbarSeverity] = useState("warning");
    const [message, setMessage] = useState('');
    const [generateReport, setGenerateReport] = useState(false)
    const [ledgerBalanceLsit, setLedgerBalanceList] = useState([])
    const [lederDatetime, setLedgerDatetime] = useState(null)
    const [submitButtonLoading, setSubmitButtonLoading] = useState(false)

    const [excelLoadingId, setExcelLoadingId] = useState(null);
    const handleBack = () => {
        history.push('/reportCards');
    };

    const formatCurrency = (value) => value ? `₹${value.toLocaleString("en-IN")}` : "₹0";


    const getGstLedgerList = () => {
        axios
            .get(`/gstn_get_ledger/get_list/${localStorage.getItem('business_entity_id')}`)
            .then((res) => {
                if (res?.data?.status === true) {
                    setGstLedgerList(res?.data?.data);
                }
            })
            .catch((error) => {
            });
    };

    const handleSnackbarOpen = (message, severity) => {
        setSnackbarOpen(true);
        setSnackbarSeverity(severity);
        setMessage(message);
    };

    const handleSnackbarClose = () => {
        setSnackbarOpen(false);
    };


    useEffect(() => {
        getGstLedgerList();
        getLedgerBalanceDetails()
    }, []);


    useEffect(() => {
        if (successMessage) {
            const timer = setTimeout(() => {
                setSuccessMessage("");
            }, 300000);

            return () => clearTimeout(timer);
        }
    }, [successMessage]);

    const getLedgerBalanceDetails = () => {
        axios.post('/gstn_get_ledger/get_ledger_balance', { business_entity_id: localStorage.getItem('business_entity_id') })
            .then((res) => {
                if (res?.data?.status) {
                    setLedgerBalanceList(res?.data?.records)
                    setLedgerDatetime(res?.data?.datetime)
                }
            }).catch((err) => {

            })
    }

    const getOtpForAuthHandler = () => {
        let payload = {
            user_name: username,
            business_entity_id: localStorage.getItem("business_entity_id"),
        };

        axios
            .post("/gstn_get_ledger/send_otp", payload)
            .then((res) => {
                if (res?.data?.status === true) {
                    if (res?.data?.is_authenticated === true && res?.data?.is_otp_sent === false) {
                        setOpenOTPModal(false);
                        if (res?.data?.message === "Connection established.") {
                            setSuccessMessage(res?.data?.message);
                            setAuthToken(res?.data?.auth_token);
                        }
                        handleSnackbarOpen(res?.data?.message, 'success')
                        closeEstablisConnectionDrawerHamdler();
                    }
                    else if (res?.data?.is_authenticated === false && res?.data?.is_otp_sent === true) {
                        setOpenOTPModal(true);
                        handleSnackbarOpen(res?.data?.message, 'success')

                    } else {
                        setOpenOTPModal(true);
                        setOtpApidata({
                            ...otpApiData,
                            transaction_id: res?.data?.transaction_id,
                            app_key: res?.data?.app_key,
                        });
                    }
                } else {
                    handleSnackbarOpen(res?.data?.error, 'error')
                    setOpenOTPModal(false);
                    setEstablisConnectionButton("button-outlined-secondary");
                }
            })
            .catch((error) => {
                console.log(error?.response?.message);
            });
    };


    const closeEstablisConnectionDrawerHamdler = () => {
        setOpenEstablisConnectionDrawer(false);
        setUserName("");
    };


    const vyanaAuthHandler = () => {

        let payload = {
            user_name: username,
            business_entity_id: localStorage.getItem("business_entity_id"),
            app_key: otpApiData?.app_key,
            transaction_id: otpApiData?.transaction_id,
            otp: auth_otp,
        };

        axios
            .post("/gstn_get_ledger/authenticate", payload)
            .then((res) => {
                if (res?.data?.status === true) {
                    setOpenOTPModal(false);
                    setOpenEstablisConnectionDrawer(false);
                    setEstablisConnectionButton("button-connection-established");
                    setAuthApiResData({
                        ...authAPiResData,
                        sek: res?.data?.sek,
                        auth_token: res?.data?.auth_token,
                    });
                    getGstLedgerList();
                    handleSnackbarOpen(res?.data?.message, 'success')
                    setTimeout(() => {
                        setEstablisConnectionButton("button-outlined-secondary");
                    }, 300000);
                } else {
                    handleSnackbarOpen(res?.data?.error, 'error')
                    setOpenOTPModal(true);
                    setEstablisConnectionButton("button-outlined-secondary");
                }
            })
            .catch((error) => {
                console.log(error?.response?.message);
                setOpenOTPModal(true);
                setEstablisConnectionButton("button-outlined-secondary");
            });
    };


    const closeOptModalHandler = () => {
        setAuthOTP("");
        setOpenOTPModal(false);
    };





    const downloadBase64Excel = (contentType, base64Data, fileName) => {
        const linkSource = `data:${contentType};base64,${base64Data}`;
        const downloadLink = document.createElement("a");
        downloadLink.href = linkSource;
        downloadLink.download = fileName;
        downloadLink.click();
    };


    const handleExcel = (item) => {
        setExcelLoadingId(item.id);
        const payload = {
            "business_entity_id": localStorage.getItem("business_entity_id"),
            "report_id": item.id
        };
        axios
            .post("/gstn_get_ledger/generate_gstn_ledger_report", payload)
            .then((response) => {
                const contentType =
                    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
                const base64Data = response?.data?.file;
                if (base64Data) {
                    downloadBase64Excel(contentType, base64Data, `${item.report_type}.xlsx`);
                } else {
                    console.error("Base64 data is missing in the response");
                }
            })
            .catch((error) => {
                console.log(error)
            })
            .finally(() => setExcelLoadingId(null));
    };


    const onSubmitHandler = () => {
        if (establishConnectionButton === "button-outlined-secondary" && !authToken) {
            handleSnackbarOpen("Please establish connection.", "warning")
            return
        }

        setSubmitButtonLoading(true)

        const FromMonth = moment(fromDateAndMonthAndYear).format("DD-MM-YYYY");
        const ToMonth = moment(toDateAndMonthAndYear).format("DD-MM-YYYY");

        axios
            .post('/gstn_get_ledger/gstn_ledger_fetch_api', {
                business_entity_id: localStorage.getItem("business_entity_id"),
                user_name: username,
                from_date: FromMonth,
                to_date: ToMonth,
                report_type: selectedReportType
            })
            .then((res) => {
                if (res?.data?.status) {
                    getGstLedgerList()
                    getLedgerBalanceDetails()
                    handleSnackbarOpen(res?.data?.message, 'success')
                    setFromDateAndMonthAndYear("")
                    setToDateAndMonthAndYear("")
                    setFromDateMonthYearDisplay(null)
                    setToDateMonthYearDisplay(null)
                } else {
                    handleSnackbarOpen(res?.data?.message, 'error')
                }
            })
            .catch((err) => {

            }).finally(() => {
                setSubmitButtonLoading(false)
            });

    };


    const inputHandlerFromDatePicker = (v) => {
        setFromDateMonthYearDisplay(v);
        setFromDateAndMonthAndYear(v);
    };

    //............function for To(DatePicker)...............
    const inputHandlerToDatePicker = (v) => {
        setToDateMonthYearDisplay(v);
        setToDateAndMonthAndYear(v);
    };

    const onClickViewReport = (report_id) => {
        history.push(`/GstLederReport/${report_id}`)

    }


    return (
        <div>
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "16px" }}>
                <Tooltip title="Back" arrow>
                    <IconButton
                        onClick={handleBack}
                        sx={{
                            borderRadius: '50%',
                            padding: '6px',
                            color: '#263238',
                            fontSize: '20px',
                            backgroundColor: '#ffffff',
                            height: '36px',
                            width: '36px',
                            '&:hover': {
                                backgroundColor: '#455a64',
                                color: '#ffffff',
                            },
                            boxShadow: '0 4px 8px rgba(0, 0, 0, 0.15)',
                            transition: 'background-color 0.3s ease',
                        }}
                    >
                        <ArrowBackIcon sx={{ fontSize: '20px' }} />
                    </IconButton>
                </Tooltip>
                {/* establish connection for vayana */}
                <div style={{ display: "flex", gap: "12px", alignItems: "center" }}>
                    {canWrite("GST LEDGERS") && (
                        successMessage === "Connection established." ? (
                            <Button variant="contained" color="success" style={{ fontSize: '13px', padding: '4px 8px' }}>
                                Connection Established
                            </Button>
                        ) : (
                            <button
                                className={establishConnectionButton}
                                onClick={() => setOpenEstablisConnectionDrawer(true)}
                            >
                                {establishConnectionButton === "button-outlined-secondary"
                                    ? "Establish Connection"
                                    : "Connection Established"
                                }
                            </button>
                        )
                    )}
                    {canWrite("GST LEDGERS") &&
                        openOTPModal && <button className="button-outlined-secondary" onClick={() => setOpenOTPModal(true)}>Verify OTP</button>
                    }
                </div>
            </div>

           {canWrite("GST LEDGERS") && (
            <div
                style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "10px",
                    fontFamily: "'Roboto', sans-serif",
                    width: "100%",
                    marginTop: '1%'
                }}
            >
                <ToggleSwitch
                    onChange={() =>
                        setGenerateReport(!generateReport)
                    }
                    value={generateReport}
                    label="GENERATE REPORT"
                />
            </div>
            )}

            {/*  */}
            <RightDrawer
                drawerName="Establish Connection"
                open={openEstablisConnectionDrawer}
            >
                <ValidatorForm
                    ref={form}
                    onSubmit={getOtpForAuthHandler}
                    onError={(errors) => console.log(errors)}
                >
                    <Inputfield
                        textLabel="User Name"
                        inputType="text"
                        name="user_name"
                        value={username}
                        textOnchangeFunction={(e) => setUserName(e.target.value)}
                        requiredField="*"
                        validator={["required"]}
                        errorMsg={["This field is required"]}
                    />
                    <div className="mt-20">
                        <button className="button-primary" type="submit">
                            Submit
                        </button>
                        <button
                            className="button-outlined-secondary"
                            type="button"
                            onClick={closeEstablisConnectionDrawerHamdler}
                        >
                            Close
                        </button>
                    </div>
                </ValidatorForm>
            </RightDrawer>

            <Modal open={openOTPModal}>
                <Box sx={style}>
                    <ValidatorForm
                        ref={form}
                        onSubmit={vyanaAuthHandler}
                        onError={(errors) => console.log(errors)}
                    >
                        <Inputfield
                            textLabel="OTP"
                            inputType="text"
                            name="OTP"
                            value={auth_otp}
                            textOnchangeFunction={(e) => setAuthOTP(e.target.value)}
                            requiredField="*"
                            validator={["required"]}
                            errorMsg={["This field is required"]}
                        />
                        <div className="mt-20">
                            <button className="button-primary" type="submit">
                                Submit
                            </button>
                            <button
                                className="button-outlined-secondary"
                                type="button"
                                onClick={closeOptModalHandler}
                            >
                                Close
                            </button>
                        </div>
                    </ValidatorForm>
                </Box>
            </Modal>

            {/*  */}
            {generateReport &&
                <BoxWrapper boxTitle="FILTER">
                    <ValidatorForm
                        ref={form}
                        onSubmit={onSubmitHandler}
                        onError={(errors) => console.log(errors)}
                    >
                        <Grid container spacing={3}>

                            <Grid item sm={3}>
                                <label>
                                    From Date<span style={{ color: "red" }}>*</span>:
                                </label>
                                <DatePicker
                                    maxDate={toDateMonthYearDisplay ?? ''}
                                    placeholder="From Date"
                                    errorMessages={["This field is required"]}
                                    validators={["required"]}
                                    value={fromDateMonthYearDisplay ?? ""}
                                    onChange={(v) => inputHandlerFromDatePicker(v)}
                                />
                            </Grid>
                            <Grid item sm={3}>
                                <label>
                                    To Date<span style={{ color: "red" }}>*</span>:
                                </label>
                                <DatePicker
                                    minDateForDatepicker={fromDateMonthYearDisplay ?? ""}
                                    placeholder="To Date"
                                    errorMessages={["This field is required"]}
                                    validators={["required"]}
                                    value={toDateMonthYearDisplay ?? ""}
                                    onChange={(v) => inputHandlerToDatePicker(v)}
                                />
                            </Grid>


                            <Grid item sm={3}>
                                <FormControl style={{ flex: '1', width: '100%', marginTop: "28px" }} variant="outlined">
                                    <InputLabel>Report Type</InputLabel>
                                    <Select
                                        value={selectedReportType}
                                        onChange={(e) => setSelectedReportType(e.target.value)}
                                        label="Report Type*"
                                        fullWidth
                                        style={{ height: '40px' }}
                                    >
                                        <MenuItem value="CASH">CASH LEDGER</MenuItem>
                                        <MenuItem value="ITC">CREDIT LEDGER</MenuItem>
                                        <MenuItem value="REVRCLM">CREDIT REVERSAL LEDGER</MenuItem>
                                        <MenuItem value="RCMLDG">RCM LIABILITY LEDGER</MenuItem>
                                        <MenuItem value="TAX">LIABILITY LEDGER</MenuItem>
                                    </Select>
                                </FormControl>
                            </Grid>
                            <Grid item sm={3}>
                                <div style={{ marginTop: "27px" }}>
                                    {submitButtonLoading ? (
                                        <button
                                            type="button"
                                            className="button-outlined-primary"
                                            style={{
                                                padding: "8px 15px",
                                                width: '90px',
                                                height: "40px" // Match the height of your button
                                            }}
                                        >
                                            <CircularProgress size={24} />
                                        </button>
                                    ) : (
                                        <button
                                            type="submit"
                                            className="button-primary"
                                            style={{
                                                width: '90px',
                                                padding: "8px 15px",
                                                height: "40px", // Ensure button has the same height
                                            }}
                                        >
                                            Submit
                                        </button>
                                    )}
                                </div>
                            </Grid>
                        </Grid>
                    </ValidatorForm>
                    <p style={{ color: "red" }}>{errorForFileUploadForm}</p>
                </BoxWrapper>
            }
            {/*  */}

            <BoxWrapper
                boxTitle="LEDGER BALANCE"
                enableIcon1={true}
                enableIcon1Value={
                    <Tooltip title='Refresh'>
                        <RefreshIcon color="primary" sx={{ fontSize: '30px' }} />
                    </Tooltip>
                }
                handleIcon1ClickFunction={() => getLedgerBalanceDetails()}
            >
                <div className="responsive-table">
                    <table className="custome-table">
                        <thead>
                            <tr>
                                <th>LEDGER</th>
                                <th>IGST(₹)</th>
                                <th>CGST(₹)</th>
                                <th>SGST(₹)</th>
                                <th>CESS(₹)</th>
                                <th>REPORT DATE</th>

                            </tr>
                        </thead>
                        <tbody>
                            {(ledgerBalanceLsit && ledgerBalanceLsit.length >= 1) ? (
                                ledgerBalanceLsit.map((v, i) => (
                                    <tr key={i}>
                                        <td>{v.type}</td>
                                        <td>{formatCurrency(v.igst_bal)}</td>
                                        <td>{formatCurrency(v.cgst_bal)}</td>
                                        <td>{formatCurrency(v.sgst_bal)}</td>
                                        <td>{formatCurrency(v.cess_bal)}</td>
                                        <td>{v.transaction_date}</td>
                                    </tr>
                                ))
                            ) : (
                                <tr>
                                    <td style={{ color: "red", textAlign: "center" }} colSpan={5}>
                                        No Data Found!
                                    </td>
                                </tr>
                            )}
                        </tbody>

                    </table>
                </div>
            </BoxWrapper>

            <BoxWrapper boxTitle="GST LEDGER">
                <div className="responsive-table">
                    <table className="custome-table">
                        <thead>
                            <tr>
                                <th>from Period</th>
                                <th>to Period</th>
                                <th>Run Date Time</th>
                                <th>Report Type</th>
                                <th>Report Status</th>
                                <th>Action</th>
                            </tr>
                        </thead>
                        <tbody>
                            {(gstLederList && gstLederList.length >= 1) ? (
                                gstLederList.map((v, i) => (
                                    <tr key={i}>
                                        <td>{v.from_date}</td>
                                        <td>{v.to_date}</td>
                                        <td>{v.run_date_time}</td>
                                        <td>{v.report_type}</td>
                                        <td>

                                            {v?.report_status &&
                                                <Chip
                                                    label={v?.report_status}
                                                    color={
                                                        v?.report_status.includes("GENERATED")
                                                            ? "success"
                                                            : "warning"
                                                    }
                                                    variant="outlined"
                                                />
                                            }
                                        </td>
                                        <td>
                                            {v?.report_status === "GENERATED" && (
                                                <RemoveRedEyeOutlinedIcon
                                                    className="action-icon-button showIcon"
                                                    onClick={() => onClickViewReport(v.id)}
                                                />
                                            )}

                                            {
                                                v?.report_status === "GENERATED" && (
                                                    excelLoadingId === v.id ? (
                                                        <CircularProgress size={18} style={{ marginLeft: '5px' }} />
                                                    ) : (
                                                        <img
                                                            onClick={() => handleExcel(v)}
                                                            style={{ marginLeft: '5px', height: '23px', width: '25px', cursor: 'pointer' }}
                                                            src={excelIconImage}
                                                        />
                                                    )
                                                )
                                            }
                                        </td>

                                    </tr>
                                ))
                            ) : (
                                <tr>
                                    <td style={{ color: "red", textAlign: "center" }} colSpan={6}>
                                        No Data Found!
                                    </td>
                                </tr>
                            )}
                        </tbody>

                    </table>
                </div>
            </BoxWrapper>

            <Snackbar
                open={snackbarOpen}
                autoHideDuration={4000}
                onClose={() => setSnackbarOpen(false)}
                anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
                TransitionProps={{
                    timeout: 500, // animation time (fade in/out)
                    onExit: () => setSnackbarOpen(false),
                }}
            >
                <Alert onClose={() => setSnackbarOpen(false)} severity={snackbarSeverity} sx={{ width: "100%" }}>
                    {message}
                </Alert>
            </Snackbar>
        </div>
    );
};
export default GstLedgers; 
